import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.modal.major_shareholder_check.title',
        defaultMessage: `Director and Shareholder details`
    },
    explanation: {
        id: '_.modal.major_shareholder_check.explanation',
        defaultMessage: `We need details of all directors and all major shareholders (25% or more shares in the business), as we’re required to run anti-money laundering checks (don’t worry, this won’t affect anyone’s credit score).`
    },
    instructions: {
        id: '_.modal.major_shareholder_check.instructions',
        defaultMessage: `You can fill out their details in the {link}, and then come back here to continue.`
    },
    link: {
        id: '_.modal.major_shareholder_check.link',
        defaultMessage: `Profile page`
    },
    proceedButton: {
        id: '_.modal.major_shareholder_check.proceed',
        defaultMessage: `I've filled in all details`
    },
    peopleTitle: {
        id: '_.modal.major_shareholder_check.peopleTitle',
        defaultMessage: `Directors and Shareholders`
    },
    peopleSubtitle: {
        id: '_.modal.major_shareholder_check.peopleSubtitle',
        defaultMessage: `We need details of all directors and all major shareholders (25% or more shares in the business), as we’re required to run anti-money laundering checks (don’t worry, this won’t affect anyone’s credit score).`
    },
    fraudAlertMessage: {
        id: '_.modal.major_shareholder_check.fraud_alert_message',
        defaultMessage: 'We need this to protect against fraud'
    },
    addPersonError: {
        id: '_.modal.major_shareholder_check.add_person_error',
        defaultMessage: 'Sorry there was an error, please try again'
    },
    fundingRequirementsLoading: {
        id: '_.modal.major_shareholder_check.funding_requirements_loading',
        defaultMessage:
            'Please wait, it can take up to 10 seconds to recheck your requirements'
    },
    addPersonCTA: {
        id: '_.modal.major_shareholder_check.add_person_cta',
        defaultMessage: 'Add another person +'
    },
    addPersonSuccessContinue: {
        id: '_.modal.major_shareholder_check.add_person_success_continue',
        defaultMessage: 'Click here'
    },
    didNotResolveFundingRequirementError: {
        id: '_.modal.major_shareholder_check.did_not_resolve_funding_requirement_error',
        defaultMessage:
            "Looks like we need more information, please try again. If you're having trouble, please"
    },
    didNotResolveFundingRequirementErrorLink: {
        id: '_.modal.major_shareholder_check.did_not_resolve_funding_requirement_error_link',
        defaultMessage: 'give us a call'
    },
    successMessage: {
        id: '_.modal.major_shareholder_check.success_message',
        defaultMessage: "Success! You've completed this requirement."
    },
    successMessageCTA: {
        id: '_.modal.major_shareholder_check.success_message_cta',
        defaultMessage: 'Click here to close this window'
    }
});
